import { toast } from "sonner";

// Helper functions for different toast types
export const showToast = {
  success: (message, options = {}) => {
    return toast.success(message, {
      duration: 3000,
      ...options,
    });
  },
  
  error: (message, options = {}) => {
    return toast.error(message, {
      duration: 4000, // Longer duration for errors
      ...options,
    });
  },
  
  warning: (message, options = {}) => {
    return toast.warning(message, {
      duration: 3500,
      ...options,
    });
  },
  
  info: (message, options = {}) => {
    return toast.info(message, {
      duration: 3000,
      ...options,
    });
  },
  
  default: (message, options = {}) => {
    return toast(message, {
      duration: 3000,
      ...options,
    });
  },
};

// Export the toast function for direct use
export { toast }; 